import useSWR from 'swr';

import { Project } from 'models';
import { ProjectCollaboratorHelpers } from 'helpers/ProjectCollaboratorHelpers';

import { ProjectCollaboratorService } from 'services/ProjectCollaboratorService';

const useProjectCollaborators = (projectId?: Project['id'] | null) => {
    const key = projectId ? ProjectCollaboratorHelpers.swr.list(projectId) : null;

    const { data: collaborators = [], ...swr } = useSWR(key, () => ProjectCollaboratorService.list(projectId!));

    return { ...swr, collaborators };
};

export { useProjectCollaborators };
